import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { doLogin, loginFailed } from "../redux/actions/Session";
import { Form, Input, Button, Icon, message } from 'antd'
import { stylesLogin } from '../styles/styles'
import "../styles/Login.css";
import logo from "../assets/logo.png"
// import logoOxxo from "../assets/oxxo-r.png"
import imgLogin from "../assets/img-login.png"


class Login extends Component {
    
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.state = {
            user: "",
            password: ""
        }
    }

    async handleSubmit(e) {
        e.preventDefault()
        if(this.state.user === "" || this.state.password === ""){
            message.warn("Por favor llene todos los campos para iniciar sesión")
        }else{
            this.props.doLogin(this.state)
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot){
        if(this.props.session.error){
            // message.error(this.props.session.error)
            // this.props.loginFailed({error: null})
        }
    }


    render() {
        console.log("SESS", this.props.session)
        return (
            <div className="mainDiv" style={stylesLogin.mainDiv}>
                <div className="leftImage">
                    <img src={imgLogin} alt="" width="100%"></img>
                </div>
                <div  className="rightImage">
                    <Form layout="vertical" onSubmit={this.handleSubmit} style={stylesLogin.form}>
                        <Form.Item>
                            <div style={{display:"flex", alignItems: "center", justifyContent:"center",marginTop: 20}}>
                                <img src={logo} alt="" width="80%"/>
                                {/* <img src={logoOxxo} alt=""  width="40%"/> */}
                            </div>
                        </Form.Item>
                        <Form.Item>
                            <Input
                                prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)'}} />}
                                placeholder="Correo"
                                value={this.state.user}
                                onChange={event => this.setState({ user: event.target.value })}
                            />
                        </Form.Item>
                        <Form.Item>
                            <Input
                                prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)'}} />}
                                type="password"
                                placeholder="Contraseña"
                                value={this.state.password}
                                onChange={event => this.setState({ password: event.target.value })}
                            />
                        </Form.Item>
                        <Form.Item>
                            {this.props.session && this.props.session.error ? <text style={{textAlign: "center", color: "red"}}>{this.props.session.error}</text> : null}
                        </Form.Item>
                        <Form.Item>
                            <Button type="primary" htmlType="submit" className="loginButton" style={stylesLogin.button}>
                                Iniciar sesion
                        </Button>
                        </Form.Item>
                    </Form>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return { session: state.session, firebase: state.firebase.app }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({ doLogin, loginFailed }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);